import React, {useState} from 'react';
import Pagination from 'react-js-pagination';
import {useSelector, useDispatch} from 'react-redux';
import {NavLink, useHistory, useLocation} from 'react-router-dom';
import {toast} from 'react-toastify';
import {
    accountPagingAction,
    deleteAccountAction,
    filterListAccount
} from '@store/reducers/account';
import Table from 'react-bootstrap/Table';
import {
    createUrlWithParam,
    getInfomationAccountFromToken
} from '../../utils/helper';
import {URI_INTERNAL} from '../../utils/pathLocations';
import {objectShowNumber, messageToast, role} from '../../utils/define';
import {ConfirmModal} from '../../modules/modal/ConfirmModal';

const Account = () => {
    const history = useHistory();
    const location = useLocation();
    const dispatch = useDispatch();
    const valueSearch = useSelector((state) => state.search.valueSearch);
    const totalAccount = useSelector((state) => state.account.totalAccount);
    const listAccount = useSelector((state) => state.account.listAccount);

    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(20);
    const [search, setSearch] = useState('');
    const [searchUsername, setSearchUsername] = useState('');
    const [searchHoTen, setSearchHoTen] = useState('');

    const [openConfirmDeleteModal, setOpenConfirmDeleteModal] = useState(false);
    const [idWantDelete, setIdWantDelete] = useState('');
    const [confirmDelMessage, setConfirmDelMessage] = useState('');

    let accountRoleAdmin = false;
    let accountRoleManager = false;
    const inforAccount = getInfomationAccountFromToken();

    if (inforAccount && inforAccount.role) {
        const userRole = inforAccount.role.split(',').map(r => r.trim().toLowerCase());
        accountRoleAdmin = userRole.includes(role.Admin.toLowerCase());
        accountRoleManager = userRole.includes(role.Manager.toLowerCase());
    }

    const paramUrl = new URLSearchParams(location.search.substring(1));
    if (
        paramUrl.get('page') != null &&
        parseInt(paramUrl.get('page'), 10) !== page
    ) {
        const pageResult = parseInt(paramUrl.get('page'), 10);
        setPage(pageResult);
    }
    if (
        paramUrl.get('size') != null &&
        parseInt(paramUrl.get('size'), 10) !== pageSize
    ) {
        const sizeResult = parseInt(paramUrl.get('size'), 10);
        setPageSize(sizeResult);
    }
    if (paramUrl.get('search') != null && paramUrl.get('search') !== search) {
        setSearch(paramUrl.get('search'));
    }


    const model = {
        query: search
    };

    const replaceHistory = async (Page, Size, Search, UsernameParam, HoTenParam) => {
        const modelPost = {
            Keyword: Search,
            Username: UsernameParam,
            HoTen: HoTenParam,
            PageIndex: Page,
            PageSize: Size
        };
        await dispatch(accountPagingAction(modelPost));

        history.replace(
            createUrlWithParam(URI_INTERNAL.ACCOUNT_PATH, {
                page: Page,
                size: Size,
                search: Search,
                username: UsernameParam,
                hoten: HoTenParam
            })
        );
    };

    React.useEffect(() => {
        let q = search;
        if (valueSearch != null && valueSearch !== search) {
            q = valueSearch;
            setSearch(q);
        }
        replaceHistory(page, pageSize, q, searchUsername, searchHoTen);
    }, [valueSearch]);

    React.useEffect(() => {
        const params = new URLSearchParams(location.search);
        setSearchUsername(params.get('username') || '');
        setSearchHoTen(params.get('hoten') || '');
    }, [location.search]);

    const changePage = (number) => {
        setPage(number);
        replaceHistory(number, pageSize, search, searchUsername, searchHoTen);
    };

    const onChangeShowNumber = (e) => {
        setPageSize(e.target.value);
        replaceHistory(page, e.target.value, search, searchUsername, searchHoTen);
    };

    const handleSearch = () => {
        setPage(1);
        replaceHistory(1, pageSize, search, searchUsername, searchHoTen);
    };

    const handleClearSearch = () => {
        setSearchUsername('');
        setSearchHoTen('');
        setPage(1);
        replaceHistory(1, pageSize, search, '', '');
    };

    const deleteAction = (id, name) => {
        setIdWantDelete(id);
        setConfirmDelMessage(name);
        setOpenConfirmDeleteModal(true);
    };

    const acceptDelete = async () => {
        if (idWantDelete !== '') {
            try {
                const result = await dispatch(
                    deleteAccountAction(idWantDelete)
                );
                if (result.payload.errors) {
                    toast.error(result.payload.errors.content[0]);
                }
                if (result.payload === 200) {
                    await dispatch(filterListAccount(idWantDelete));
                    toast.success(messageToast.messageToastDeleteSuccess);
                    // history.goBack();

                    if (
                        listAccount != null &&
                        listAccount.length === 1 &&
                        page !== 1
                    ) {
                        history.push(
                            createUrlWithParam(URI_INTERNAL.DEVICE_PATH, {
                                page: page - 1,
                                size: pageSize,
                                search: search
                            })
                        );
                    }
                }
            } catch (error) {
                toast.error(messageToast.messageToastTryCatch);
            }
            setOpenConfirmDeleteModal(false);
        }
    };

    const cancelDelete = () => {
        setIdWantDelete('');
        setOpenConfirmDeleteModal(false);
    };

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-lg-12">
                    <div className="card">
                        <div className="card-header">
                            <h3 className="card-title"> Danh sách tài khoản</h3>
                        </div>
                        <div className="card-body">
                            <div className="d-flex flex-column flex-sm-row justify-content-between align-items-stretch align-items-sm-center" style={{ gap: '10px' }}>
                                <form className="form-inline d-flex align-items-center">
                                    <label
                                        htmlFor="exampleEmail2"
                                        className="mr-2 mb-0"
                                        style={{ whiteSpace: 'nowrap' }}
                                    >
                                        Hiển thị :
                                    </label>
                                    <select
                                        className="form-control"
                                        value={pageSize}
                                        onChange={(e) => onChangeShowNumber(e)}
                                        style={{ width: '100px' }}
                                    >
                                        {objectShowNumber.map((item, key) => (
                                            <option
                                                key={Number(key)}
                                                value={item.value}
                                            >
                                                {item.text}
                                            </option>
                                        ))}
                                    </select>
                                </form>
                                <NavLink
                                    className="nav-link-reject nav-link p-0"
                                    to={URI_INTERNAL.ACCOUNT_PATH_ADD}
                                >
                                    <button
                                        type="button"
                                        className="btn btn-info px-4"
                                    >
                                        Thêm mới
                                    </button>
                                </NavLink>
                            </div>
                            
                            {/* Bộ lọc tìm kiếm tài khoản */}
                            <div className="row mt-3 bg-light p-3 rounded align-items-center" style={{ marginLeft: 0, marginRight: 0, border: '1px solid #dee2e6' }}>
                                <div className="col-md-4 mb-2 mb-md-0">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Tìm theo Username..."
                                        value={searchUsername}
                                        onChange={(e) => setSearchUsername(e.target.value)}
                                        onKeyPress={(e) => e.key === 'Enter' && handleSearch()}
                                    />
                                </div>
                                <div className="col-md-4 mb-2 mb-md-0">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Tìm theo Họ tên nhân viên..."
                                        value={searchHoTen}
                                        onChange={(e) => setSearchHoTen(e.target.value)}
                                        onKeyPress={(e) => e.key === 'Enter' && handleSearch()}
                                    />
                                </div>
                                <div className="col-md-4 d-flex" style={{ gap: '8px' }}>
                                    <button
                                        type="button"
                                        className="btn btn-primary flex-fill"
                                        onClick={handleSearch}
                                    >
                                        <i className="fas fa-search mr-1" /> Tìm kiếm
                                    </button>
                                    <button
                                        type="button"
                                        className="btn btn-default flex-fill"
                                        onClick={handleClearSearch}
                                    >
                                        <i className="fas fa-undo mr-1" /> Xóa lọc
                                    </button>
                                </div>
                            </div>

                            <div
                                id="example2_wrapper"
                                className="dataTables_wrapper dt-bootstrap4"
                                style={{marginTop: '20px'}}
                            >
                                <div className="row">
                                    <div className="col-sm-12">
                                        <Table striped bordered hover responsive>
                                            <thead>
                                                <tr role="row">
                                                    <th className="sorting" style={{ width: '60px' }}>
                                                        STT
                                                    </th>
                                                    <th className="sorting">
                                                        Tài khoản (Username)
                                                    </th>
                                                    <th className="sorting">
                                                        Họ tên nhân viên
                                                    </th>
                                                    <th className="sorting">
                                                        Trạng thái
                                                    </th>
                                                    <th className="sorting" style={{ width: '120px' }}>
                                                        Chức năng
                                                    </th>
                                                </tr>
                                            </thead>
                                            {listAccount != null &&
                                            listAccount !== undefined &&
                                            listAccount.length > 0 ? (
                                                <tbody>
                                                    {listAccount.map(
                                                        (item, index) => {
                                                            return (
                                                                <tr
                                                                    key={Number(
                                                                        index
                                                                    )}
                                                                    className="odd"
                                                                >
                                                                    <td className="dtr-control sorting_1">
                                                                        {index +
                                                                            1 +
                                                                            (page -
                                                                                1) *
                                                                                pageSize}
                                                                    </td>
                                                                    <td>
                                                                        {
                                                                            item.username
                                                                        }
                                                                    </td>
                                                                    <td>
                                                                        {
                                                                            item.tenNhanVien || item.fullName || '-'
                                                                        }
                                                                    </td>
                                                                    <td>
                                                                        <div
                                                                            className={
                                                                                item.isActive
                                                                                    ? 'icheck-primary'
                                                                                    : 'icheck-danger'
                                                                            }
                                                                        >
                                                                            <input
                                                                                type="radio"
                                                                                id={
                                                                                    item.id
                                                                                }
                                                                                name={
                                                                                    item.id
                                                                                }
                                                                                defaultChecked
                                                                            />
                                                                            <label
                                                                                htmlFor={
                                                                                    item.id
                                                                                }
                                                                            >
                                                                                {item.isActive
                                                                                    ? 'Đã kích hoạt'
                                                                                    : 'Chưa kích hoạt'}
                                                                            </label>
                                                                        </div>
                                                                    </td>
                                                                    <td>
                                                                        <ul className="nav">
                                                                            {(() => {
                                                                                const isTargetAdmin = item.roles && item.roles.split(',').map(r => r.trim().toLowerCase()).includes(role.Admin.toLowerCase());
                                                                                const showEditButton = accountRoleAdmin || (accountRoleManager && !isTargetAdmin);
                                                                                return showEditButton && (
                                                                                    <li className="nav-item">
                                                                                        <NavLink
                                                                                            to={createUrlWithParam(
                                                                                                URI_INTERNAL.ACCOUNT_PATH_EDIT,
                                                                                                {
                                                                                                    id: item.id
                                                                                                }
                                                                                            )}
                                                                                            exact
                                                                                            className="nav-link"
                                                                                        >
                                                                                            <i
                                                                                                title="Sửa"
                                                                                                className="nav-icon font-icon fas fa-pen"
                                                                                            />
                                                                                        </NavLink>
                                                                                    </li>
                                                                                );
                                                                            })()}
                                                                            {/* <li className="nav-item">
                                                                                {accountRoleAdmin ? (
                                                                                    <NavLink
                                                                                        onClick={() =>
                                                                                            deleteAction(
                                                                                                item.id,
                                                                                                item.username
                                                                                            )
                                                                                        }
                                                                                        to
                                                                                        exact
                                                                                        className="nav-link"
                                                                                    >
                                                                                        <i
                                                                                            title="Xóa"
                                                                                            className="nav-icon font-icon far fa-trash-alt"
                                                                                        />
                                                                                    </NavLink>
                                                                                ) : (
                                                                                    <>
                                                                                    </>
                                                                                )}
                                                                            </li> */}
                                                                        </ul>
                                                                    </td>
                                                                </tr>
                                                            );
                                                        }
                                                    )}
                                                </tbody>
                                            ) : (
                                                <tbody>
                                                    <tr className="txt-center">
                                                        <td colSpan="12">
                                                            Không có dữ liệu
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            )}
                                            <tfoot>
                                                <tr role="row">
                                                    <th className="sorting">
                                                        STT
                                                    </th>
                                                    <th className="sorting">
                                                        Tài khoản
                                                    </th>
                                                    <th className="sorting">
                                                        Họ tên nhân viên
                                                    </th>
                                                    <th className="sorting">
                                                        Trạng thái
                                                    </th>
                                                    <th className="sorting">
                                                        Chức năng
                                                    </th>
                                                </tr>
                                            </tfoot>
                                        </Table>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-12">
                                        <div
                                            className="dataTables_paginate paging_simple_numbers"
                                            id="example2_paginate"
                                        >
                                            <Pagination
                                                itemClass="page-item"
                                                linkClass="page-link"
                                                innerClass="pagination pagination-sm no-margin pull-right"
                                                activePage={page}
                                                itemsCountPerPage={Number(
                                                    pageSize
                                                )}
                                                totalItemsCount={totalAccount}
                                                pageRangeDisplayed={5}
                                                onChange={(number) =>
                                                    changePage(number)
                                                }
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <ConfirmModal
                                isOpen={openConfirmDeleteModal}
                                confirmType="delete"
                                handleAccept={() => acceptDelete()}
                                handleCancel={() => cancelDelete()}
                                content={confirmDelMessage}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Account;
